module.exports = __webpack_public_path__ + "media/images/svg/twitter-6456a4ea3f51bbef59acd6e3e7f143ca.svg";